import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { closeButton, logo } from '../../assets/images/images';
import { handleUpgrade } from '../../utility/tierUtils';
import { ROUTES } from '../../resources/routes-constants';

const DisclaimerModal = ({
    show,
    onHide,
    onAccept
}: {
    show: boolean;
    onHide: () => void;
    onAccept: () => void;
}) => {
    const navigate = useNavigate();

    const handleUpgradeClick = () => {
        onAccept(); // Close the modal first
        handleUpgrade(navigate, ROUTES.CONTACT_US_TO_UPGRADE_ROUTE);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            dialogClassName="modal-600 modal-dialog-centered"
            className="disclaimer-modal"
            backdrop="static"
            keyboard={false}
        >
            <img 
                src={closeButton} 
                alt="Close" 
                className="cross-btn" 
                onClick={onHide}
            />
            <Modal.Body>
                <div className="disclaimer-logo">
                    <img 
                        src={logo} 
                        alt="SBR2TH Logo" 
                        className="modal-logo" 
                    />
                </div>
                
                <div className="disclaimer-header">
                    <h4 className="modal-head modal-head-medium">Welcome to SBR2TH AI</h4>
                </div>
                
                <div className="disclaimer-content">
                    <div className="disclaimer-welcome">
                        <p className="welcome-message">
                            Thank you for joining SBR2TH AI.
                        </p>
                        <p className="general-message">
                            Your smarter way to connect with top-tier talent. We're excited to help you discover the right candidates, faster.
                        </p>
                    </div>
                    
                    <div className="disclaimer-section">
                        <h5>About Your Demo Account</h5>
                        <p>
                            You're exploring the demo version, with a few limits:
                        </p>
                        <ul className="demo-limitations">
                            <li>Access to a sample of up to <strong>20%</strong> of our full candidate network</li>
                            <li>Candidate profiles are <strong>partially masked</strong> for privacy until you upgrade</li>
                            <li>You can create up to <strong>two job descriptions</strong></li>
                            <li><strong>Deleting or downloading candidates</strong> is disabled within demo accounts</li>
                        </ul>
                        <p>
                            The full version unlocks our entire verified talent pool, provides richer insights, and offers advanced matching intelligence, along with the full suite of functionality to accelerate your hiring activities. If you would like to upgrade now,{' '}
                            <button 
                                onClick={handleUpgradeClick}
                                className="upgrade-link"
                                style={{ 
                                    background: 'none', 
                                    border: 'none', 
                                    color: '#3DCBB1', 
                                    textDecoration: 'underline', 
                                    cursor: 'pointer',
                                    padding: 0,
                                    font: 'inherit'
                                }}
                            >
                                click here
                            </button>.
                        </p>
                    </div>
                    
                    <div className="disclaimer-section">
                        <h5>Discover What's Possible</h5>
                        <p>
                            Get a feel for how effortless hiring can be.
                        </p>
                        <p>
                            When you're ready for the complete experience, we'll help you unlock the full power of SBR2TH AI.
                        </p>
                    </div>
                </div>
                
                <div className="modal-footer">
                    <Button 
                        className="btn-continue" 
                        onClick={onAccept}
                    >
                        Continue
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DisclaimerModal;
